module.exports = __webpack_public_path__ + "static/media/card-img1.b3b237f5.webp";